import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';

import radioField from './radio';
import inputField from './input';
import selectField from './select';

import Copy from '../copy-to-clipboard';
import Tooltip from '../tooltip';

lessRequire('modules/shared/form-elements/domain-parking.less');

const DomainParkingSection = props => {
	const {
		fieldNames,
		disabledStatus,
		domainOptions,
		linkToCopy,
		linkToCopyLabel,
		shouldShowTooltip,
		InstructionsSection,
		intl
	} = props;
	const { domainType, subdomain, internalDomain, externalDomain } = fieldNames;

	return (
		<div className="park-domain clearfix">
			<div className="park-domain__section">
				<div className="park-domain-row">
					<Field
						name={domainType}
						defaultValue="internal"
						labelText={intl('Использовать наш домен')}
						component={radioField}
					/>
				</div>

				<div className="park-domain-row clearfix">
					<div className="park-domain__field-inline">
						<Field
							name={subdomain}
							placeholder={intl('Сабдомен')}
							shouldDisable={disabledStatus[subdomain]}
							component={inputField}
						/>
						{shouldShowTooltip &&
							<Tooltip>{intl('Оставьте поле пустым и сабдомен будет сгенерирован автоматически.')}</Tooltip>}
					</div>

					<div className="park-domain__field-inline">
						<Field
							name={internalDomain}
							placeholder={intl('Домен')}
							shouldDisable={disabledStatus[internalDomain]}
							component={selectField}
							options={domainOptions}
						/>
					</div>
				</div>
			</div>

			<div className="park-domain__section">
				<div className="park-domain-row">
					<Field
						name={domainType}
						defaultValue="external"
						labelText={intl('Припарковать домен')}
						component={radioField}
					/>
				</div>
				<div className="park-domain__field-inline">
					<Field
						name={externalDomain}
						placeholder={intl('Домен')}
						shouldDisable={disabledStatus[externalDomain]}
						component={inputField}
					/>
				</div>
			</div>

			<div className="park-domain__section">
				<InstructionsSection intl={intl} />
			</div>

			{linkToCopy &&
				linkToCopyLabel &&
				<div className="link-copy">
					<span className="link-copy__title">{linkToCopyLabel} </span>
					<span className="link-copy__url">
						<Copy copyText={linkToCopy} intl={intl}>
							<span className="link-copy__url-value" title={linkToCopy}>{linkToCopy}</span>
						</Copy>
					</span>
				</div>}
		</div>
	);
};

DomainParkingSection.propTypes = {
	fieldNames: PropTypes.object,
	disabledStatus: PropTypes.object,
	domainOptions: PropTypes.array,
	linkToCopy: PropTypes.string,
	linkToCopyLabel: PropTypes.string,
	shouldShowTooltip: PropTypes.bool,
	InstructionsSection: PropTypes.func,
	intl: PropTypes.func
};

export default DomainParkingSection;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/form-elements/domain-parking.js